import { useState } from "react";
import AccordionComponent from "../AccordionComponent";

export default function WhatWeDo() {
  const services = [
    {
      question: "Content Owners",
      answer:
        "VVV is a UGC licensing firm that uniquely empowers content owners to unlock new revenue streams through seamless content distribution and sublicensing initiatives, maximizing earnings with minimal effort. We generate roughly $800,000 USD per month in revenue for our clients as of Q4 2024.",
    },
    {
      question: "Distributors",
      answer:
        "VVV Distribution is a hack to fame and virality on YouTube. You’ll be able to use the internet’s best clips, and better yet, earn money from doing so. Promote our clips, get paid. Go wild!",
    },
    {
      question: "Enterprise / TV",
      answer:
        "We’re offering boutique accounts to select media / TV channels and brands to browse and download curated clips and collections from our video library to engage their audience.",
    },
  ];

  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <div className="p-6 lg:p-12 relative overflow-hidden 4xl:max-w-[100rem] 4xl:mx-auto">
      <div className="flex flex-col lg:flex-row justify-between items-center text-white">
        <div className="lg:w-1/2 space-y-14">
          <div className="space-y-6 text-center lg:text-left">
            <div className="space-y-2">
              <p className="text-white/70">Our Services</p>
              <h1 className="uppercase text-4xl md:text-5xl vvv-font">
                What We Do
              </h1>
            </div>
            <p className="text-sm md:text-base">
              We partner with enthusiast content creators and media brands to
              build profitable digital enterprises. Leveraging our advanced
              technology and monetization expertise, we provide turnkey services
              designed to maximize viewership and boost revenue.
            </p>
          </div>
          <div className="w-full flex flex-col items-stretch pr-1">
            {services.map((faq, idx) => (
              <AccordionComponent
                key={idx}
                question={faq.question}
                answer={faq.answer}
                isOpen={openIndex === idx}
                onClick={() => handleToggle(idx)}
                containerHeight="lg:h-[113px] xl:h-[104px] 1xl:h-[130px]"
              />
            ))}
          </div>
        </div>
        <div className="relative overflow-hidden flex items-center justify-center lg:w-1/2">
          <video
            preload="metadata"
            loading="lazy"
            autoPlay
            muted
            loop
            playsInline
            className="min-w-[800px] md:min-w-[900px] xl:min-w-[1300px] object-cover lg:ml-12"
          >
            <source
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/what-we-do.mp4"
              type="video/mp4"
            />
          </video>
        </div>
      </div>
    </div>
  );
}
